import validateRut from './validateRut'

export const validateRutHelper = validateRut
